export default __webpack_public_path__ + "static/media/push.5b9ecb19.wav";